(function (global, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else global.NBBWelcomeProductExperiment = factory();
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var KEY = 'nbb_product_placement_v1';
  var END = Date.parse('2026-10-13T02:00:00.000Z');
  var WINDOW = 14 * 86400000;
  function create(win, options) {
    var doc = win.document, storage = null;
    try { storage = win.localStorage; } catch (_error) {}
    var fetcher = options.fetch || win.fetch.bind(win), now = options.now || Date.now;
    var params = new URL(win.location.href).searchParams;
    var qa = params.get('welcome_popup_test') === '1';
    var current = null, pending = null, cartPending = null, observer = null, destroyed = false;
    var sent = new Set();
    function allowed() {
      try { return win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_error) { return false; }
    }
    function get(key) { try { return storage.getItem(key); } catch (_error) { return null; } }
    function set(key, value) { try { storage.setItem(key, value); return storage.getItem(key) === value; } catch (_error) { return false; } }
    function valid(value) {
      return value && ['control', 'floating'].includes(value.arm) && ['scratch', 'premium'].includes(value.rewardVariant) &&
        /^[a-f0-9-]{36}\.[a-f0-9]{64}$/.test(value.token || '') &&
        Number.isFinite(Date.parse(value.enrolledAt)) && now() < Date.parse(value.enrolledAt) + WINDOW;
    }
    function token() { return !qa && allowed() && valid(current) ? current.token : ''; }
    async function post(body) {
      var response = await fetcher(options.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true, signal: win.AbortSignal && win.AbortSignal.timeout ? win.AbortSignal.timeout(5000) : undefined });
      if (!response.ok) throw new Error('experiment_unavailable');
      return response.json();
    }
    async function event(name) {
      var t = token();
      if (!t || sent.has(name)) return;
      sent.add(name);
      try { await post({ operation: 'event', token: t, event: name }); }
      catch (_error) { sent.delete(name); }
    }
    function forms() {
      var t = token();
      doc.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (!form.querySelector('[type="submit"]')) return;
        var input = form.querySelector('input[name="properties[_nbb_pdp_experiment]"]');
        if (!t) { if (input) input.remove(); return; }
        if (!input) { input = doc.createElement('input'); input.type = 'hidden'; input.name = 'properties[_nbb_pdp_experiment]'; form.appendChild(input); }
        if (input.value !== t) input.value = t;
      });
    }
    function carry() {
      forms();
      if (!token() || cartPending || destroyed) return cartPending;
      var t = token();
      cartPending = fetcher((win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { nbb_pdp_experiment__: t } }), keepalive: true,
        signal: win.AbortSignal && win.AbortSignal.timeout ? win.AbortSignal.timeout(5000) : undefined
      }).then(function (response) { return event(response.ok ? 'cart_linked' : 'cart_link_failed'); }, function () { return event('cart_link_failed'); });
      return cartPending;
    }
    async function resume() {
      if (qa || !allowed() || destroyed) return;
      try { var saved = JSON.parse(get(KEY) || 'null'); current = valid(saved) ? saved : null; } catch (_error) { current = null; }
      if (current) await carry();
    }
    var privacyReady = new Promise(function (resolve) {
      if (win.Shopify && win.Shopify.customerPrivacy) { resolve(); return; }
      if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
        win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { resolve(); });
        win.setTimeout(resolve, 4000);
      } else resolve();
    });
    async function enroll(rewardVariant, device, locale) {
      if (qa) return { arm: params.get('product_placement_variant') === 'control' ? 'control' : 'floating', rewardVariant: rewardVariant };
      await privacyReady;
      if (!allowed() || destroyed) return null;
      await resume();
      if (current) return current;
      if (now() >= END) return null;
      if (pending) return pending;
      var id = get(KEY + '_visitor');
      if (!id) { id = win.crypto.randomUUID(); if (!set(KEY + '_visitor', id)) return null; }
      pending = post({ operation: 'enroll', visitorId: id, rewardVariant: rewardVariant, device: device, locale: locale }).then(async function (result) {
        if (!allowed() || destroyed || !valid(result.assignment)) return null;
        current = result.assignment;
        set(KEY, JSON.stringify(current));
        await carry();
        return current;
      }).catch(function () { return null; }).finally(function () { pending = null; });
      return pending;
    }
    function privacyChanged() {
      if (!allowed()) {
        // Clear checkout carry-forward on withdrawal; existing cohort history is not reassigned.
        var previousToken = current && current.token;
        if (!qa && previousToken) post({ operation: 'withdraw', token: previousToken }).catch(function () {});
        try { if (!qa) storage.removeItem(KEY); } catch (_error) {}
        current = null; forms(); cartPending = null;
        if (!qa) fetcher((win.Shopify.routes && win.Shopify.routes.root || '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ attributes: { nbb_pdp_experiment__: '' } })
        }).catch(function () {});
      } else resume().then(function () { doc.dispatchEvent(new win.CustomEvent('nbb:product-experiment-ready')); });
    }
    doc.addEventListener('visitorConsentCollected', privacyChanged);
    doc.addEventListener('submit', forms, true);
    if (!qa && win.MutationObserver) { observer = new win.MutationObserver(forms); observer.observe(doc.body, { childList: true, subtree: true }); }
    privacyReady.then(resume);
    return { enroll: enroll, token: token, event: event, allowed: allowed, destroy: function () {
      destroyed = true; if (observer) observer.disconnect();
      doc.removeEventListener('visitorConsentCollected', privacyChanged); doc.removeEventListener('submit', forms, true);
    } };
  }
  return { create: create };
}));
